import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { DownloadForOffline } from '@mui/icons-material';
import { Button } from '@mui/material';
import { DataFormatter } from 'shared/components/data-display/DataFormatter';
import { NumberEditor } from 'shared/components/data-display/editors';
import { vlanDistributionTypes } from 'features/networking/core/helper';
import { withStaticSelect } from 'shared/components/data-display/withSelectors';
import { useRequest } from 'shared/hooks';
import { complexVtrUpgradeAudit } from 'shared/api/networking';
import { DataReducerActions } from 'shared/reducers';
import VlanEditDialog from 'features/networking/complex/VlanEditDialog';

const descriptions = [{
  label: 'VLAN Start',
  key: 'vlan_range_start',
  editor: NumberEditor,
},
{
  label: 'VLAN End',
  key: 'vlan_range_end',
  editor: NumberEditor,
},
{
  label: 'VLAN Margin',
  key: 'vlan_margin',
  editor: NumberEditor,
},
{
  label: 'Ordering',
  key: 'vlan_distribution_type',
  editor: withStaticSelect({
    valueAsLabel: true,
    options: vlanDistributionTypes,
    disableClearable: true,
  }),
},
];

/**
 * @param {Object} props
 * @param {Object} props.state - State object containing complex data
 * @param {Function} props.dispatch - Dispatch function for reducer actions
 */
export default function VlansPanel({ state, dispatch }) {
  const { request } = useRequest();
  const {
    data: { id, buildings },
    updatedData,
  } = state;
  const minVlan = 2048;
  const maxVlan = 3999;
  const vlanMargin = 5;
  const vlanDistributionType = 'standard';

  const exportComplexVTRAudit = async () => request(
    complexVtrUpgradeAudit(id),
    'Download complete',
    true,
  );
  return (
    <Grid
      container
      sx={{ justifyContent: 'end' }}
    >
      <DataFormatter
        data={{
          vlan_range_start: minVlan,
          vlan_range_end: maxVlan,
          vlan_margin: vlanMargin,
          vlan_distribution_type: vlanDistributionType,
        }}
        descriptions={descriptions}
        editing
        updateValue={(key, value) => dispatch({
          action: DataReducerActions.update,
          payload: { key, value },
        })}
        updatedData={updatedData}
      />
      <Grid>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="outlined"
            startIcon={<DownloadForOffline />}
            onClick={exportComplexVTRAudit}
          >
            Upgrade Audit
          </Button>
          <VlanEditDialog
            complexId={id}
            vlanMargin={updatedData.vlan_margin || vlanMargin}
            minVlan={updatedData.vlan_range_start || minVlan}
            maxVlan={updatedData.vlan_range_end || maxVlan}
            vlanDistributionType={updatedData.vlan_distribution_type || vlanDistributionType}
            hasBuildings={buildings.length > 0}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
